import React, {useEffect, useState} from "react";
import {Col, Container, Form, Row} from "react-bootstrap";
import UserDashboardPageUserMenu from "../@@Parts/@Menu";
import {UserDashboardPageContent, UserDashboardPageContentSection} from "@Pages/@@UserPages/@Dashboard/@@Parts";
import {ButtonComponent, FormDropdownComponent} from "@Components/Forms";
import IconSettingsS from "./@Icons/icon-settings-s-grey.svg";
import IconDisconnectS from "./@Icons/icon-disconnect-s-grey.svg";
import IconConnectS from "./@Icons/icon-connect-s-grey.svg";
import GmailLogo from "./@Icons/gmail_logo.svg";
import OutlookLogo from "./@Icons/logo-outlook.svg";
import ButtonPlus from "./@Icons/button-plus-icon.svg";
import {SvgIconComponent} from "@Components/Elements";
import SystemCommunicateElementComponent from "@Components/@Elements/@Popups/@SystemCommunicate";
import UserDashboardUserMenuComponent from "@Pages/@@UserPages/@@Dashboard/@@@Menu";


export const UserDashboardSettingsPage:React.FC = () => {

    const [systemCommunicateMessage, setSystemCommunicateMessage] = useState('');

    const [profileSettingVisibilityEmailAddressSetting, setProfileSettingVisibilityEmailAddressSetting] = useState(0);

    const changeProfileSettingVisibilityEmailAddressSetting = (optionID: number) => {
        setProfileSettingVisibilityEmailAddressSetting(optionID);
        changeOptionValueHandler();
    };

    useEffect(() => {
        setProfileSettingVisibilityEmailAddressSetting(1);
    }, []);

    useEffect(() => {
        return () => {
            setProfileSettingVisibilityEmailAddressSetting(0);
        };
    }, []);

    const changeOptionValueHandler = () => {
        setSystemCommunicateMessage('Changes Saved');
    };

    return (
        <Container className={'user-dashboard-page-container'}>
            <Row className={'user-dashboard-page-container__content'}>

                {systemCommunicateMessage &&
                <SystemCommunicateElementComponent
                    communicateType={'success'}
                    communicateText={systemCommunicateMessage}
                    communicateCloseCallback={() => setSystemCommunicateMessage('')}
                />
                }

                {/*<UserDashboardPageUserMenu />*/}

                <UserDashboardUserMenuComponent />

                <UserDashboardPageContent
                    headingText={'Settings'}
                    descriptionText={'Manage your preferences and app behavior'}
                >


                    <UserDashboardPageContentSection
                        sectionName={'user-settings-general'}
                        sectionHeaderText={'General Settings'}
                    >

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-header'}>
                            <span>Language & Region</span>
                        </Col>

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-content'}>
                            <Row className={'user-dashboard-page__page-content__content-section__section-content__sub-section-content__content'}>
                                <Col xs={12} lg={3}>
                                    <Row>
                                        <FormDropdownComponent
                                            fieldLabelText={'App Language'}
                                            fieldOptions={[{ optionID: 1, optionValue: 'English (US)' }, { optionID: 2, optionValue: 'Polish (PL)' }]}
                                            optionChoiceHandler={() => undefined}
                                            selectedOptionID={1}
                                            fieldDisabledStatus={true}
                                        />
                                    </Row>
                                </Col>
                                <Col xs={12} lg={3} style={{ marginLeft: '24px' }}>
                                    <Row>
                                        <FormDropdownComponent
                                            fieldLabelText={'Date Format'}
                                            fieldOptions={[{ optionID: 1, optionValue: 'MM/DD/YYYY' }, { optionID: 2, optionValue: 'YYYY/MM/DD' }]}
                                            optionChoiceHandler={() => undefined}
                                            selectedOptionID={1}
                                            fieldDisabledStatus={true}
                                        />
                                    </Row>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-header'}>
                            <span>Theme & Appearance</span>
                        </Col>

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-content'}>
                            <Row className={'user-dashboard-page__page-content__content-section__section-content__sub-section-content__content'}>

                                <Col xs={12} lg={6} className={'user-dashboard-radio-options-element'}>
                                    <Row className={'user-dashboard-radio-options-element__content'}>
                                        <Col xs={12} className={'user-dashboard-radio-options-element__options-header'}>
                                            <span>Theme Mode</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-radio-options-element__options-description'}>
                                            <span>Choose your preferred color scheme</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-radio-options-element__options-list'}>
                                            <Row className={'user-dashboard-radio-options-element__options-list__content'}>
                                                <Col xs={12} className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input checked disabled'}></span>
                                                    <span className={'radio-button-label'}>Light</span>
                                                </Col>
                                                <Col xs={12}
                                                     className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input disabled'}></span>
                                                    <span className={'radio-button-label'}>Dark</span>
                                                </Col>
                                                <Col xs={12}
                                                     className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input disabled'}></span>
                                                    <span className={'radio-button-label'}>Auto</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                                <Col xs={12} lg={6} className={'user-dashboard-radio-options-element'}>
                                    <Row className={'user-dashboard-radio-options-element__content'}>
                                        <Col xs={12} className={'user-dashboard-radio-options-element__options-header'}>
                                            <span>Font size</span>
                                        </Col>
                                        <Col xs={12}
                                             className={'user-dashboard-radio-options-element__options-description'}>
                                            <span>Choose your preferred color scheme</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-radio-options-element__options-list'}>
                                            <Row className={'user-dashboard-radio-options-element__options-list__content'}>
                                                <Col xs={12} className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input disabled'}></span>
                                                    <span className={'radio-button-label'}>Small</span>
                                                </Col>
                                                <Col xs={12}
                                                     className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input checked disabled'}></span>
                                                    <span className={'radio-button-label'}>Medium</span>
                                                </Col>
                                                <Col xs={12}
                                                     className={'user-dashboard-radio-options-element__options-list__radio-option'}>
                                                    <span className={'radio-button-input disabled'}></span>
                                                    <span className={'radio-button-label'}>Large</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Col>

                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>


                    <UserDashboardPageContentSection
                        sectionName={'user-settings-notifications'}
                        sectionHeaderText={'Notifications'}
                    >

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-header'}>
                            <span>Email notifications</span>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Claim Updates</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Get notified when your claims status changes</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Marketing & Promotions</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Receive updates about new features and offers</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Weekly Summary</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Receive weekly reports of your activity</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-page__page-content__content-section__section-content__sub-section-header'}>
                            <span>Push notifications</span>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Browser Notifications</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Get instant notifications in your browser</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Sound Alerts</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Play sound when receiving notifications</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>


                    <UserDashboardPageContentSection
                        sectionName={'user-settings-privacy'}
                        sectionHeaderText={'Privacy & Visibility'}
                    >

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Email Notifications</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Receive updates about your claims</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={4} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <FormDropdownComponent
                                        fieldOptions={[{ optionID: 1, optionValue: 'Public' }, { optionID: 2, optionValue: 'Private' }]}
                                        optionChoiceHandler={(optionID) => changeProfileSettingVisibilityEmailAddressSetting(optionID)}
                                        selectedOptionID={profileSettingVisibilityEmailAddressSetting}
                                        // fieldDisabledStatus={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={10} lg={11} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Analytics & Tracking</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Help improve our service with usage data</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={2} lg={1} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <Form.Check type={'switch'} disabled={false} onChange={changeOptionValueHandler} />
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={12} className={'user-dashboard-switch-option-element'}>
                            <Row className={'user-dashboard-switch-option-element__content'}>
                                <Col xs={8} lg={10} className={'user-dashboard-switch-option-element__option-content'}>
                                    <Row className={'user-dashboard-switch-option-element__option-content__content'}>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-header'}>
                                            <span>Cookie Preferences</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-switch-option-element__option-content__option-description'}>
                                            <span>Manage your cookie settings</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={4} lg={2} className={'user-dashboard-switch-option-element__option-switcher'}>
                                    <ButtonComponent
                                        text={'Manage'} iconLeft={IconSettingsS} type={'flat'}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>


                    <UserDashboardPageContentSection
                        sectionName={'user-settings-privacy'}
                        sectionHeaderText={'Connected Apps'}
                    >

                        {/*<Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                        {/*    <Row className={'user-dashboard-connected-app-element__content'}>*/}
                        {/*        <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                        {/*            <SvgIconComponent iconSource={GmailLogo} />*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                        {/*            <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                        {/*                    <span>Gmail</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                        {/*                    <span>Connected for email parsing</span>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                        {/*            <ButtonComponent*/}
                        {/*                text={'Disconnect'}*/}
                        {/*                type={'flat'} iconLeft={IconDisconnectS}*/}
                        {/*                buttonDisabled={true}*/}
                        {/*            />*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                        {/*<Col xs={12} className={'user-dashboard-connected-app-element'}>*/}
                        {/*    <Row className={'user-dashboard-connected-app-element__content'}>*/}
                        {/*        <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>*/}
                        {/*            <SvgIconComponent iconSource={OutlookLogo} />*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>*/}
                        {/*            <Row className={'user-dashboard-connected-app-element__app-information__content'}>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>*/}
                        {/*                    <span>Outlook</span>*/}
                        {/*                </Col>*/}
                        {/*                <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>*/}
                        {/*                    <span>Connected for email parsing</span>*/}
                        {/*                </Col>*/}
                        {/*            </Row>*/}
                        {/*        </Col>*/}
                        {/*        <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>*/}
                        {/*            <ButtonComponent*/}
                        {/*                text={'Disconnect'}*/}
                        {/*                type={'flat'} iconLeft={IconDisconnectS}*/}
                        {/*                buttonDisabled={true}*/}
                        {/*            />*/}
                        {/*        </Col>*/}
                        {/*    </Row>*/}
                        {/*</Col>*/}

                        <Col xs={12} className={'user-dashboard-connected-app-element'}>
                            <Row className={'user-dashboard-connected-app-element__content'}>
                                <Col xs={2} lg={1} className={'user-dashboard-connected-app-element__app-icon'}>
                                    <SvgIconComponent iconSource={ButtonPlus} />
                                </Col>
                                <Col xs={10} lg={9} className={'user-dashboard-connected-app-element__app-information'}>
                                    <Row className={'user-dashboard-connected-app-element__app-information__content'}>
                                        <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-name'}>
                                            <span>Connect New App</span>
                                        </Col>
                                        <Col xs={12} className={'user-dashboard-connected-app-element__app-information__app-description'}>
                                            <span>Add another email provider</span>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col xs={12} lg={2} className={'user-dashboard-connected-app-element__app-options'}>
                                    <ButtonComponent
                                        text={'Connect'}
                                        type={'flat'} iconLeft={IconConnectS}
                                        buttonDisabled={true}
                                    />
                                </Col>
                            </Row>
                        </Col>

                    </UserDashboardPageContentSection>


                </UserDashboardPageContent>

            </Row>
        </Container>
    );

};


export default UserDashboardSettingsPage;
